/**
 * Created by lei.sun on 2017/9/17.
 */

import * as types from './mutations-types';
import actions from './actions';
import {
    extend
} from 'lodash';
import * as modules from './modules';

const state = {

};

// getters
const getters = {

};

// mutations
const mutations = {

};

export default {
    state,
    getters,
    actions,
    mutations,
    modules
}



// WEBPACK FOOTER //
// ./src/store/Admin/index.js